import { useNavigate } from 'react-router-dom';
import { downloadExcelTemplate } from '../utils/exportTemplateExcel';
import { useRef, useState } from 'react';
import { importFromExcel } from '../utils/importFromExcel';
import { get_all_beneficiaries } from '../api/beneficiary_api';
import { exportAllStudentsToExcel } from '../utils/exportToExcel';
import '../styles/MainScreen.css';
import ContactsTab from './ContactsTab';
import Footer from './Footer';
import { logout } from '../api/auth_api';


const MainScreen = () => {
    const navigate = useNavigate();
    const [importing, setImporting] = useState(false);
    const fileInputRef = useRef();
    const [showContacts, setShowContacts] = useState(false);

    const handleDonors = () => {
        navigate(`/donors`);
    };
    const handleFileChange = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        setImporting(true);
        try {
            await importFromExcel(file);
        } catch (err) {
            console.error(err);
            alert('טעינת התלמידות נכשלה');
        } finally {
            setImporting(false);
            e.target.value = '';
        }
    };


    const handleRequestsClick = () => {
        navigate('/RequestManagement');
    };

    const handleSendFormClick = () => {
        navigate('/send_request');
    }

    const handleDocumentsClick = () => {
        navigate('/DocumentsImportant');
    };

    // const clicking_budget = () => {
    //     navigate('/budget');
    // };

    return (
        <div className="main-screen">
            <div className="main-screen-header">
                <div className="main-screen-icon">
                    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="8" y="8" width="40" height="40" rx="12" fill="#fff" /> {/* שינוי רקע אייקון */}
                        <path d="M28 18C32.4183 18 36 21.5817 36 26C36 30.4183 32.4183 34 28 34C23.5817 34 20 30.4183 20 26C20 21.5817 23.5817 18 28 18Z" fill="currentColor" />
                        <path d="M16 40C16 35.5817 21.5817 32 28 32C34.4183 32 40 35.5817 40 40" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </div>
                <h1>תוכנה לניהול עמותה</h1>
            </div>

            <div className="main-screen-buttons-section">

                <h2 className="section-title">פעולות ליבה וניהול</h2>
                <div className="main-screen-buttons-grid">
                    <button className="main-action-btn" onClick={() => navigate(`/beneficiaries`)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                        </svg>
                        ניהול נתמכים
                    </button>
                    {/* <button className="main-action-btn" onClick={handleDonors}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                        </svg>
                        ניהול תורמים
                    </button> */}
                    <button className="main-action-btn" onClick={handleRequestsClick}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M4 17h16M4 13h16M8 9V7a4 4 0 1 1 8 0v2" />
                            <rect x="3" y="3" width="18" height="18" rx="2" />
                        </svg>
                        ניהול בקשות
                    </button>
                    <button className="main-action-btn" onClick={handleSendFormClick}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <rect x="3" y="5" width="18" height="14" rx="2" />
                            <polyline points="3 7 12 13 21 7" />
                            <line x1="12" y1="13" x2="12" y2="21" />
                        </svg>
                        שליחת בקשה לסיוע
                    </button>
                </div>

                <h2 className="section-title">ייבוא וייצוא נתונים</h2>
                <div className="main-screen-buttons-grid">
                    <button className="main-action-btn" title="הורדת תבנית אקסל" onClick={() => downloadExcelTemplate()}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M14 2v6h6" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12 11v6m0 0l-3-3m3 3l3-3" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        תבנית אקסל
                    </button>
                    <button
                        className="main-action-btn"
                        title="ייבוא מאקסל"
                        disabled={importing}
                        onClick={() => !importing && fileInputRef.current.click()}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                            <path d="M12 12v7m0 0l-3-3m3 3l3-3" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M4 4h16v4" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        ייבוא מאקסל
                    </button>
                    <button className="main-action-btn" title="ייצוא לאקסל" onClick={async () => {
                        try {
                            await exportAllStudentsToExcel();
                        } catch (error) {
                            console.error('Export failed:', error);
                            alert(`שגיאה בייצוא: ${error.message}`);
                        }
                    }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                            <path d="M12 3v12m0 0l-4-4m4 4l4-4M4 21h16" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        ייצוא לאקסל
                    </button>
                </div>

                <h2 className="section-title">לוח בקרה</h2>
                <div className="main-screen-buttons-grid">
                    <button className="main-action-btn" onClick={() => setShowContacts(true)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                        </svg>
                        אנשי קשר
                    </button>
                    <button className="main-action-btn" onClick={() => navigate('/budget')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="white" strokeWidth="2" viewBox="0 0 24 24">
                        <path d="M4 20V10" />
                        <path d="M10 20V4" />
                        <path d="M16 20v-7" />
                        <path d="M22 20H2" />
                    </svg>
                        נתוני תקציב
                    </button>
                    <button className="main-action-btn" onClick={handleDocumentsClick}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                            <polyline points="14 2 14 8 20 8"></polyline>
                            <line x1="16" y1="13" x2="8" y2="13"></line>
                            <line x1="16" y1="17" x2="8" y2="17"></line>
                            <polyline points="10 9 9 9 8 9"></polyline>
                        </svg>
                        מסמכים חשובים
                    </button>
                </div>
            </div>

            <input
                type="file"
                accept=".xlsx, .xls"
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleFileChange}
            />

            {showContacts && <ContactsTab onClose={() => setShowContacts(false)} />}

            <Footer onLogout={() => {
                if (window.confirm('האם אתה בטוח שברצונך להתנתק?')) {
                    logout();
                }
            }} />
        </div>
    );
};

export default MainScreen;
